const basePath = process.env.REACT_APP_BASEPATH || '';

export default basePath;
